export default __webpack_public_path__ + "static/media/hsat-change.03c5307f.svg";